import React from 'react'
import { ESPACO_TEIA_LOGO_URL } from 'components/branding/espacoTeiaBranding.styles'
import { FooterWrapper, FooterLinksWrapper, FooterCopyright, FooterHr, FooterLogo, FooterLogoLink } from './styles'
import { trans } from 'sharedKernel/i18n'

export const HotsiteFooter = (): JSX.Element => {

  const labels = {
    rightsReserved: trans('St. de Divulgação Cultural 636X+QQ - Brasília, DF, 70655-775')
  }

  return (
    <FooterWrapper fluid>
      <FooterLinksWrapper>
        <FooterLogoLink href="/">
          <FooterLogo src={ESPACO_TEIA_LOGO_URL} alt="Espaço TEIA Caixa" loading="lazy" />
        </FooterLogoLink>
        <FooterHr />
        <FooterHr />
        <FooterHr />
        <FooterHr />
        <FooterCopyright>{labels.rightsReserved}</FooterCopyright>
      </FooterLinksWrapper>
    </FooterWrapper >
  )
}
